(function($) {

	$.fn.msxiinit = function() {

		return this.each(function() {
			var $this = $(this);

			// Allow a link to be disabled
            $('a').click(function(e) {
                if(e.target.getAttribute("data-disabled") === "true") {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            });

            $(document).one('afterAsyncDropdownList', function(){
                afterAsyncDropdownList($this);
            });
            // Init all JQuery plugins
            $this.uniqueFormInputIds();
            $this.find('form.attachments-form').attachmentsform();
            $this.find('.autocomplete').msxiautocomplete();
            $this.find('.autosearch-widget').msxiautosearch();
            $this.find("body").msxibrowser();
            $this.find('.build-dialog').builddialog();
            $this.find('button, input[type="submit"], a.button').not('.defer-init').msxibutton();
            $this.find('.multi-button').multiButton();
            $this.find('.button-select').msxibuttonselect();
            $this.find('div.form-checkboxes.addCheckAll').msxicheckall_addcheckall();
            $this.find('input.checkAll[type="checkbox"], a.checkAll').msxicheckall();
            $this.find("table.sortable-table,table.paged-table").msxidatatable();
            $this.find('.disableLinkOnClick').disableLinkOnClick();
            $this.find('#primary-navigation').msxidropdownmenu();
            $this.find('form').not('.attachments-form').find('input[type="file"]').filter('[accept]').fileaccept();
            $this.find('.filename-field').filenamefield();
            $this.find('.form-confirm-submit').formconfirmsubmit();
            $this.find('form').not('.disableAjaxSubmit').msxiformsubmit();
            $this.find('.icon').msxiicon();
            $this.find('select.dropdownlist').not('.defer-init').dropdownlist();
            $this.find('div.combobox').not('.defer-init').combobox();
            $this.find('div.dropdowntree').dropdowntree();
            $this.find('.dependent-field').dependentformfield();
            $this.find('div.tabs').msxitabs();
            $this.find('.button-column').buttonColumn();
            $this.find('select.select-menu').msxiSelectmenu();
            $this.find('.panel').not('.tabs').add('.tabs > .panel-content').msxiPanel();
            $this.find('.panel').not('.tabs').add('.tabs > .panel-content').has('.document-grid').msxiDownloadPanel();
            $this.find('div.form-checkboxes.checkHider').msxicheckhider();
            $this.find('select').msxiSelect();
            $this.find('.overflow-on-hover').not(':has(:checkbox:disabled)').overflowHover();
            $this.find('.checkbox-tree').msxiCheckboxtree();
            $this.find('.one-field').onefield();
            $this.find('ul.breadcrumb').msxibreadcrumb();
            $this.find('#primary-navigation ul.menu').primarymenu();
            $this.find('input.spinner').msxiSpinner();
            $this.find('input.slider').msxiSlider();
            $this.find('button,input').filter(':button.reset').msxiReset();
            $this.find('.panel.collapsible').togglePanel();
            $this.find('table th .vertical').msxiRotateCell();
            $this.find('.thumbnail img').imageLoader();
            $this.find('.document-grid').documentGrid();
            $this.find('table').has('tr.description-row').tableRowHighlighter();
            $this.find('table').has('tr.detail-row').tableRowHighlighter({'selector': 'tr.detail-row'});
            $this.find('form.singleButtonForm').has('a').singleLinkForm();
            $this.find('a.user-navigation-link').userNavigation();
            $this.find('#header #idCurrentProgram').programSwitcher();
            $this.find('form.select-action-form').selectActionForm();
            var $datePickers = $this.find('input.date-picker').not('.defer-init');
            if ($datePickers.length > 0)
            {
                $.fn.msxidatepicker.afterInit.push(function(){
                    // use the afterInit callback to ensure that timepickers are only inited after datepickers (date picker init is aSync)
                    $this.find('input.time-picker').not('.defer-init').msxijtimepicker();
                });
                $datePickers.msxidatepicker();
            }
            else
            {
                $this.find('input.time-picker').not('.defer-init').msxijtimepicker();
            }
            $this.find('.msx-duration-picker').msxidurationpicker();
            $this.find('table').not('.paged-table').filter(':visible').has('col.trim').msxiTableTrimmer();
            // treetable after tabletrimmer to ensure space is allocated for collapsed branches
            $this.find('.tree-table').msxitreetable();
            $this.find('input').filter('[placeholder]').msxiplaceholder();
            $this.find('.user-details').userdetails();
            $this.find('.sortable').sortableheader();
            $this.hideMessage();
            $this.msxititle();
            $this.find('.html-tooltip,input.error[title],textarea.error[title],select.error[title],.ui-slider.error[title],img.contextual-help[title]').msxititle({'html-content': true});
            //$this.find('div.other-option').otherOption();
            $this.find('.form-checkboxes').filter(':has(.depth-1)').formcheckboxtree();
            $this.find('.deselect-radio').deselectradio();
            $this.find('input.clearable').msxiAddClear();
            //$this.find("form .dynamicListBox, div.dynamicListBox, div.dynamicBlock, div.dynamicListCheckBoxes").dynamicListBoxes();
            $this.find('.collapsible-form-filters').collapsibleFilters();
            $this.find('.calendar:visible').not('.defer-init').calendar();
            $this.find(':input.exclude-submit').excludeSubmit();
            $this.find('.multi-stage-progress-bar').multiStageProgressBar();
            $this.ieselectfix();

            setTimeout(function() {
                $this.find('tr.success-row').removeClass( "success-row",3000);
            }, 3000 );

            // Anything but IE pre version 7
            if(!$.browser.msie || parseInt($.browser.version, 10) >= 7)
            {
                $this.find('a.dialog-link').msxidialog();
            }
        });
	};

    function afterAsyncDropdownList($this) {
        // execute init of dropdown related plugins only after dropdownlist has finished init
        $this.find('div.other-option').otherOption();
        $this.find("form .dynamicListBox, div.dynamicListBox, div.dynamicBlock, div.dynamicListCheckBoxes").dynamicListBoxes();
    }

    //
	//Initialization Code
    //
    $(function() {
        $(document).msxiinit();
    });

})(jQuery);